import { Bot, LogOut, Menu, Search } from 'lucide-react';

export interface MobileTopBarProps {
  userName?: string;
  onMenuToggle: () => void;
  onLogout?: () => void;
  onOpenCommand?: () => void;
}

export function MobileTopBar({ onMenuToggle, onLogout, onOpenCommand }: MobileTopBarProps) {
  return (
    <header className="sticky top-0 z-30 flex h-16 items-center justify-between border-b border-white/10 bg-hhp-navy px-4 font-hhp-sans lg:hidden">
      {/* Left: hamburger + workspace identity */}
      <div className="flex items-center gap-3">
        <button
          onClick={onMenuToggle}
          className="rounded-xl p-2 text-white/60 transition-colors hover:bg-white/5 hover:text-white"
          aria-label="Open navigation"
        >
          <Menu className="h-5 w-5" />
        </button>

        <div className="flex items-center gap-2.5">
          <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-white p-1">
            <img src="/hhp-logo.png" alt="Happy Home Painter" className="h-full w-full object-contain" />
          </div>
          <div>
            <p className="font-hhp-display text-sm font-bold leading-none text-white">Happy Home Painter</p>
            <div className="mt-1 flex items-center gap-1.5">
              <span className="h-1.5 w-1.5 rounded-full bg-hhp-gold" />
              <span className="text-[9px] font-bold uppercase tracking-[.18em] text-hhp-gold/80">Active</span>
            </div>
          </div>
        </div>
      </div>

      {/* Right: command + search + logout */}
      <div className="flex items-center gap-2">
        {onOpenCommand && (
          <button
            onClick={onOpenCommand}
            className="rounded-xl bg-hhp-gold/15 p-2 text-hhp-gold transition hover:bg-hhp-gold/25"
            aria-label="Open assistant activity"
          >
            <Bot className="h-4 w-4" />
          </button>
        )}
        <button className="rounded-xl bg-white/5 p-2 text-white/60 transition-colors hover:text-white">
          <Search className="h-4 w-4" />
        </button>
        {onLogout && (
          <button
            onClick={onLogout}
            className="rounded-xl p-2 text-white/60 transition-colors hover:bg-white/5 hover:text-red-400"
            aria-label="Log out"
          >
            <LogOut className="h-4 w-4" />
          </button>
        )}
      </div>
    </header>
  );
}
